import Postmate from 'postmate';
import BaseCommunicator from './BaseCommunicator';

Postmate.debug = true;
export default class Communicator extends BaseCommunicator {
  constructor() {
    const model = {
      csrbuddy2: (featureFlags: unknown) => {
        window.dispatchEvent(new CustomEvent('csrbuddy2', { detail:  { featureFlags } }));
      },
      reloadStorefront: () => {
        window.dispatchEvent(new CustomEvent('reloadStorefront'));
      },
    };

    super(new Postmate.Model(model));
  }
}